/** *------------------------tab-change-element  end--------------------------------** */
import { getFontCategory } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/font';

// eslint-disable-next-line no-control-regex
export const getIsChinese = text => /.*[^\x00-\xff]+.*/.test(text);
/**
 * 这个逻辑是不准确的，只不过在目前这个函数主要用于根据文字内容生成 lang 属性，slide 中目前 lang 只解析了 latin 和 ea 两种，所以暂时可以这么用
 */
export function isLatinLang(text: string) {
    return getFontCategory(text) !== 'ea';
}

export const isSameLang = (preText, curText) => isLatinLang(preText) === isLatinLang(curText);

/**
 * 根据中西文拆分text
 * @param text
 */
export function splitTextByLanguage(text = '') {
    if (!text) return [''];
    const splitArr: any[] = [];
    let isLatinFlag: any = null;
    let tempRun = '';
    for (let i = 0; i < text.length; i++) {
        const isLatin = isLatinLang(text[i]);
        if (isLatinFlag === null) {
            isLatinFlag = isLatin; // 第一次
            tempRun += text[i];
        } else {
            if (isLatinFlag === isLatin) {
                tempRun += text[i];
            } else {
                splitArr.push(tempRun);
                isLatinFlag = isLatin; // 更新本次run的语言
                tempRun = text[i]; // 重制tmpRun
            }
        }
        if (i === text.length - 1) {
            splitArr.push(tempRun);
        }
    }
    return splitArr;
}

/**
 * textStyle 根据中西文挂上lang
 * 这个 lang 是用来匹配默认字体的
 * @param text
 * @param textRunStyle
 */
export function setLangFromText(text, textRunStyle) {
    // 判断是否是中西文来决定 lang 值
    if (isLatinLang(text)) {
        textRunStyle.lang = 'latin';
    } else {
        textRunStyle.lang = 'ea';
    }
}
